import { useEffect, useState } from "react";
import api from "../lib/api";

export default function News() {
  const [news, setNews] = useState([]);
  const [region, setRegion] = useState("");

  useEffect(() => {
    api.get("/news", { params: region ? { region } : {} }).then(r => setNews(r.data));
  }, [region]);

  const regions = ["", "United States", "Canada", "North America", "Global"];

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="news-page">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Newsroom</div>
      <h1 className="display-black text-5xl lg:text-6xl uppercase text-[#064E3B] mt-3 tracking-tighter">Industry intelligence.</h1>
      <p className="text-gray-700 mt-4 max-w-2xl">Pulse of the removal, salvage, and disposal industry — curated for operators and decision-makers.</p>

      <div className="mt-10 flex flex-wrap gap-3" data-testid="news-region-filter">
        {regions.map(r => (
          <button
            key={r || "all"}
            onClick={() => setRegion(r)}
            className={`mono text-[11px] tracking-[0.22em] uppercase px-4 py-2 border ${region === r ? "bg-[#064E3B] text-white border-[#064E3B]" : "bg-white text-[#064E3B] border-gray-300 hover:border-[#064E3B]"}`}
            data-testid={`region-${r || "all"}`}
          >
            {r || "All"}
          </button>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-px bg-gray-300 border border-gray-300">
        {news.map(n => (
          <article key={n.id} className="bento-card p-8" data-testid={`news-${n.id}`}>
            <div className="mono text-[10px] tracking-[0.22em] uppercase text-gray-500">{n.region} · {n.published}</div>
            <h3 className="display-black text-2xl uppercase text-[#064E3B] mt-3 leading-tight">{n.title}</h3>
            <p className="text-sm text-gray-700 mt-4">{n.summary}</p>
            <div className="mono text-[10px] tracking-wider uppercase text-[#D97706] mt-5">— {n.source}</div>
          </article>
        ))}
      </div>
    </div>
  );
}
